module.exports = __webpack_public_path__ + "static/media/mock-ags1.b8f0e830.png";